import { LogoMark } from '@/components/ui/logo';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { Link, useLocation } from 'react-router';

const TITLES: Record<string, string> = {
  '/today': 'Today',
  '/notes': 'Study',
  '/pyq': 'Practice',
  '/tutor': 'Tutor',
  '/drill': 'Drill',
  '/analytics': 'Progress',
  '/settings': 'Settings',
};

export function MobileTopBar() {
  const { pathname } = useLocation();
  if (pathname === '/tutor' || pathname.startsWith('/tutor/')) return null;
  // Hide top bar on Today and Spark — both pages own their full viewport and
  // a small duplicate title above just adds noise (and on Spark would eat
  // the snap-card height).
  if (pathname === '/today' || pathname === '/spark') return null;

  const title =
    TITLES[pathname] ||
    Object.entries(TITLES).find(([prefix]) => pathname.startsWith(`${prefix}/`))?.[1] ||
    'Disha';

  return (
    <header className="sticky top-0 z-30 flex h-12 items-center gap-2 border-b border-[var(--color-border)] bg-[var(--color-surface)]/92 px-4 backdrop-blur-md md:hidden">
      <Link to="/today" className="flex items-center gap-2" aria-label="Today">
        <LogoMark className="size-5 text-[var(--color-primary)]" />
        <span className="text-sm font-semibold tracking-tight">{title}</span>
      </Link>
      <ThemeToggle className="ml-auto" compact />
    </header>
  );
}
